<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

import { useAuthStore } from '@/stores/auth-store'

import ManageDefaultRemarkModal from '@/components/cargo-loading/ManageDefaultRemarkModal.vue'
import DefaultRemarksTable from '@/components/cargo-loading/DefaultRemarksTable.vue'
import MyButton from '@/components/my-components/MyButton.vue'
import MyPanel from '@/components/my-components/MyPanel.vue'
import MyTabs from '@/components/my-components/MyTabs.vue'
import CrumbsAndActions from '@/components/layout/CrumbsAndActions.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

const { t } = useI18n()
const authStore = useAuthStore()
const route = useRoute()

const manageDefaultRemarkModalOpen = ref(false)
</script>

<template>
    <CrumbsAndActions v-if="authStore.companyId">
        <Breadcrumb :to="{ name: 'cl' }" v-text="t('cargoLoading')" />
        <Breadcrumb current v-text="t('defaultRemarks')" />
        <template #actions>
            <MyButton
                plain
                scheme="primary"
                size="small"
                @click="manageDefaultRemarkModalOpen = true"
            >
                <mdi:plus-thick class="mr-1" />
                {{ t('createNew') }}
            </MyButton>
        </template>
    </CrumbsAndActions>

    <MyPanel v-if="authStore.companyId" shadow>
        <MyTabs
            :tabs="{ 'loading-lists': t('loadingLists'), routes: t('routes') }"
            default-tab="loading-lists"
        >
            <DefaultRemarksTable />
        </MyTabs>
        <ManageDefaultRemarkModal
            v-if="route.query.tab"
            :model-value="manageDefaultRemarkModalOpen"
            :for-route="route.query.tab.toString() === 'routes'"
            @close="manageDefaultRemarkModalOpen = false"
        />
    </MyPanel>
</template>
